import React, { useContext } from 'react';
import CheckboxInput from '../../../../Components/CheckBoxInput';

import CreateKeyValueInput from '../../../../Components/CreateKeyValueInput';
import ValueInput from '../../../../Components/ValueInput';
import PageHeading from '../../../../Components/PageHeading';
import { COUNTRY_CODE_MAP, countryCodesList } from '../../../../core/constants';
import { ConfigContext } from '../../../../Contexts/ConfigContext';

//mui imports====
import { Grid } from '@mui/material';
import useCommonStyles from '../../../../commonStyles';
import Paper from '@mui/material/Paper';

//===============

const HbFloorsConfig = ({ keyData , featureDescription}) => {

	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	const hbFloorsObject = (function () {
		if (!rawConfig || JSON.stringify(rawConfig) === '{}') return {};

		let newObj = {};
		for (let key in rawConfig) {
			let li = key.lastIndexOf('.');
			if (
				key.includes('networkData.hbFloorsConfig.countryWiseHbFloorMapping') &&
				key !== 'networkData.hbFloorsConfig.countryWiseHbFloorMapping'
			) {
				newObj[key.substring(li + 1)] = rawConfig[key];
			}
		}

		return newObj;
	})();

	const getKeysNotPresentInHbFloorsObject = () => {
		const hbFloorsKeys = Object.keys(hbFloorsObject);
		const filteredCountryCodes = countryCodesList.filter((code) => !hbFloorsKeys.includes(code));
		const filteredCountryCodesKeyValue = filteredCountryCodes.map((code) => {
			return {
				label: `${COUNTRY_CODE_MAP?.[code] || code} (${code})`,
				value: code
			};
		});
		return filteredCountryCodesKeyValue;
	};

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Hb Floors"
				headingPath={['Dashboard', 'Framerate', 'Network Data', 'Hb Floors']}
				description="Manage Country Wise Hb Floors Mapping"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={1} style={{ marginTop: '4rem', marginLeft: '4rem' }}>
				<Grid
					item
					xs={4}
					style={{
						display: 'flex',
						alignItems: 'center'
					}}
				>
					<CheckboxInput
						keyData={keyData + '.enabled'}
						label="Enabled"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ width: 'fit-content' }}
					/>
				</Grid>
				<Grid
					item
					xs={4}
					style={{
						display: 'flex',
						alignItems: 'center'
					}}
				>
					<CheckboxInput
						keyData={keyData + '.useHBFloorsAsUPR'}
						label="Use HBFloors As UPR"
						disabled={false}
						defaultChecked={false}
						object={rawConfig}
						updateObject={updateRawConfig}
						containerStyles={{ width: 'fit-content' }}
					/>
				</Grid>
				<Grid container spacing={2}>
					{Object.keys(hbFloorsObject).map((key) => {
						return (
							<Grid item xs={12} sm={6} key={key}>
								<ValueInput
									key={key}
									keyData={keyData + '.countryWiseHbFloorMapping'}
									label="country"
									keyValue={key}
									object={rawConfig}
									updateObject={updateRawConfig}
									generateLabel={(code) => `${COUNTRY_CODE_MAP?.[code] || code} (${code})`}
									valueType="number"
									containerStyle={{
										display: 'flex',
										justifyContent: 'flex-start',
										width: 'fit-content',
										alignItems: 'center'
									}}
								/>
							</Grid>
						);
					})}
					<Grid item xs={6}>
						<CreateKeyValueInput
							keyData={keyData + '.countryWiseHbFloorMapping'}
							label="country"
							object={rawConfig}
							updateObject={updateRawConfig}
							valueType="number"
							selectKeyDefaultWidth={'165px'}
							keyList={getKeysNotPresentInHbFloorsObject()}
							containerStyle={{
								display: 'flex',
								alignItems: 'center'
							}}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default HbFloorsConfig;
